import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema} from '/opt/buildhome/repo/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/opt/buildhome/repo/markdoc/tags.js'
import * as nodes from '/opt/buildhome/repo/markdoc/nodes.js'
const functions = {};
const schema = {
tags: tags ? (tags.default || tags) : {},
nodes: nodes ? (nodes.default || nodes) : {},
functions: functions ? (functions.default || functions) : {},
...(config ? (config.default || config) : {}),
};

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Mendable Python SDK\ndescription: Learn how to use the Mendable Python SDK to add sources and ask questions to Mendable directly from your Python code. \n---\n\nThis is a Python SDK for Mendable.ai, which provides a Python interface to interact with Mendable.ai's API.\n\n## Installation\n\nTo install this package, use pip:\n\n```bash\npip install mendable-py\n```\n\n## Prerequisites\n\nTo use this package, you'll need to obtain an API key from Mendable.ai and make it available as an environment variable.\n\nIn your environment (add to .env file):\n\n```bash\nMENDABLE_API_KEY=your_api_key\n```\n\n## Usage\n\nYou can use this package to add sources to Mendable and ask questions to it:\n\n```python\nfrom mendable import ChatApp\n\nmy_docs_bot = ChatApp()\n\nmy_docs_bot.add(\"sitemap\", \"https://docs.mendable.ai/sitemap.xml\")\n\nanswer = my_docs_bot.query(\"How to install Mendable?\")\n\nprint(answer)\n```\n\n## Supported Features\n\n- Ingesting data sources  (.add)\n- Asking questions (.query)\n\n\n## Supported ingestion formats and type\n\n- Website Crawler URL -> \"website-crawler\"\n- Docusaurus site URL -> \"docusaurus\"\n- GitHub Repo URL -> \"github\"\n- YouTube Video URL -> \"youtube\"\n- Single Website URL -> \"url\"\n- Sitemap URL -> \"sitemap\"\n- OpenAPI YAML URL -> \"openapi\"\n\n\nPlease make sure to replace `your_api_key` with your actual API key and modify any part of this README according to your needs before adding it to your package.\n\n\n[View repository](https://github.com/mendableai/mendable-py)\n";
const filepath = "/sdks/python.md";
const ast = Markdoc.parse(source);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    partials[key] = Markdoc.parse(partials[key]);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
